import { Component, OnInit } from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {AgRendererComponent} from 'ag-grid-angular';
import { IntegrationRef } from '../app.model';

@Component({
  selector: 'app-status-render',
  templateUrl: './status-render.component.html',
  styleUrls: ['./status-render.component.scss']
})
export class StatusRenderComponent implements AgRendererComponent {

  public params: ICellRendererParams;
  status: string;
  isDestination;
  isDestinationSet: boolean;


  agInit(params: ICellRendererParams): void {
      this.params = params; // console.log(this.params, "StatusRenderComponent")
      this.isDestinationSet = this.params.data['destinationName'] != null;

      // switch(this.params.data.status) {
      //   case 'CREATED': this.status = 'PENDING';  break;
      //   case 'ENABLED': this.status = 'ACTIVE'; break;
      //   case 'UPDATED': this.status = 'UPDATED';
      // }
      this.status = this.params.value;
      this.params['isDestination'] = this.isDestination;
  }

  public invokeParentMethod() {
      this.params.context.componentParent.methodFromParent(`Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef.headerName}`);
  }

  refresh(): boolean {
      return false;
  }

  routeToDetails() { // console.log("rou")
    if (this.isDestinationSet) {
      const integration: IntegrationRef = {
        'integrationName': this.params.data.integrationName,
        'sourceId': this.params.data.sourceId,
        'status': this.params.data.status,
        'destinationName': this.params.data.destinationName
      };
      this.params.context.componentParent?.routeToDetails?.(integration);
    }
  }

}
